import { LedgersState } from "./types";

export const LEDGERS_DEFAULT_STATE: LedgersState = {
  selectedAccountIds: [],
  selectedAccountBackStack: [],
  selectedAccountForwardStack: [],
  selectedSplitIds: {}
};
